import DragDropController from '@/js/Webmail/DragDrop/DragDropController';
import DragItem from '@/js/Webmail/DragDrop/Entities/DragItem';

export { DragStartDirective as default};

const DragStartDirective = {
  created(el, binding){
    el.onStart = (event) => {
      let drag_item = new DragItem;
      drag_item.event = binding.value.event;
      drag_item.element_event = event;
      drag_item.initial_data = binding.value.data || null;

      DragDropController.onDragStart(drag_item);
    }

    el.onEnd = () => {
      DragDropController.onDragEnd();
    }
  },
  mounted(el, binding) {
    if(!binding.value.event){
      return;
    }

    el.draggable = true;
    el.addEventListener('dragstart' , el.onStart);
    el.addEventListener('dragend'   , el.onEnd);
  },
  unmounted(el, binding) {
    if(!binding.value.event){
      return;
    }

    el.removeEventListener('dragstart', el.onStart);
    el.removeEventListener('dragend'  , el.onEnd);
  },
};
